export default "__VITE_ASSET__Dq_E7k_E__"